<button
    class="animated-button"
    [class.success]="buttonSuccess"
    [class.error]="buttonError"
    [class.warning]="buttonWarning"
    [class.disabled]="buttonDisabled || buttonWarning"
    [disabled]="buttonDisabled || buttonError"
    (click)="onClick()"
>
    <span class="text-section">
        <span [@textAnimationState]="textAnimationState" class="state-text">
            <span class="sync-text">
                {{ currentView?.text }}
                <span *ngIf="currentView?.withDots" class="dots-placeholder">
                    <span class="dot" [class.visible]="dotCount >= 1">.</span>
                    <span class="dot" [class.visible]="dotCount >= 2">.</span>
                    <span class="dot" [class.visible]="dotCount >= 3">.</span>
                </span>
            </span>
        </span>
    </span>

    <span class="icon-section">
        <ng-container *ngIf="currentView?.customClass; else iconTemplate">
            <span [class]="currentView.customClass"></span>
        </ng-container>

        <ng-template #iconTemplate>
            <span
                class="material-icons-outlined icon"
                [@iconAnimationState]="iconAnimationState"
                [ngClass]="{
                    warning: textAnimationState === 'warning'
                }"
            >
                {{ currentView?.icon }}
            </span>
        </ng-template>
    </span>
</button>
